/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Group_Options_DuplicateInputs */

const en_event_group_options_duplicate = /** @type {(inputs: Event_Group_Options_DuplicateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duplicate`)
};

const fr_event_group_options_duplicate = /** @type {(inputs: Event_Group_Options_DuplicateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dupliquer`)
};

const de_event_group_options_duplicate = /** @type {(inputs: Event_Group_Options_DuplicateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duplikat`)
};

const it_event_group_options_duplicate = /** @type {(inputs: Event_Group_Options_DuplicateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duplicato`)
};

const ru_event_group_options_duplicate = /** @type {(inputs: Event_Group_Options_DuplicateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Дубликат`)
};

const es_event_group_options_duplicate = /** @type {(inputs: Event_Group_Options_DuplicateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duplicado`)
};

const zh_cn2_event_group_options_duplicate = /** @type {(inputs: Event_Group_Options_DuplicateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`复制`)
};

const ja_event_group_options_duplicate = /** @type {(inputs: Event_Group_Options_DuplicateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`重複`)
};

const hi_event_group_options_duplicate = /** @type {(inputs: Event_Group_Options_DuplicateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`डुप्लिकेट`)
};

const pt_pt2_event_group_options_duplicate = /** @type {(inputs: Event_Group_Options_DuplicateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duplicado`)
};

/**
* | output |
* | --- |
* | "Duplicate" |
*
* @param {Event_Group_Options_DuplicateInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_group_options_duplicate = /** @type {((inputs?: Event_Group_Options_DuplicateInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Group_Options_DuplicateInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_event_group_options_duplicate(inputs)
	if (locale === "de") return de_event_group_options_duplicate(inputs)
	if (locale === "it") return it_event_group_options_duplicate(inputs)
	if (locale === "ru") return ru_event_group_options_duplicate(inputs)
	if (locale === "es") return es_event_group_options_duplicate(inputs)
	if (locale === "zh-CN") return zh_cn2_event_group_options_duplicate(inputs)
	if (locale === "ja") return ja_event_group_options_duplicate(inputs)
	if (locale === "hi") return hi_event_group_options_duplicate(inputs)
	if (locale === "pt-PT") return pt_pt2_event_group_options_duplicate(inputs)
	return en_event_group_options_duplicate(inputs)
});